// src/lib/consent.ts
const KEY = "consent"; // "accepted" | "declined"

/**
 * Optional: set default consent to denied BEFORE analytics loads.
 * Safe to call on app start. If analytics isn't loaded yet, it sets gtag defaults.
 */
export async function applyDefaultConsentDenied() {
  try {
    const { setConsent } = await import("firebase/analytics");
    // default = denied until user decides
    setConsent({
      ad_storage: "denied",
      analytics_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
    });
  } catch {
    /* ignore if analytics not available (e.g., SSR or unsupported browser) */
  }
}

export function getConsent(): "accepted" | "declined" | null {
  try { return (localStorage.getItem(KEY) as any) || null; } catch { return null; }
}
export function hasAccepted() { return getConsent() === "accepted"; }

export async function acceptAnalytics() {
  try {
    const { setConsent } = await import("firebase/analytics");
    setConsent({
      ad_storage: "granted",
      analytics_storage: "granted",
      ad_user_data: "denied",
      ad_personalization: "denied",
    });
  } catch {}
  try { localStorage.setItem(KEY, "accepted"); } catch {}
}

export async function declineAnalytics() {
  try {
    const { setConsent } = await import("firebase/analytics");
    setConsent({
      ad_storage: "denied",
      analytics_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
    });
  } catch {}
  try { localStorage.setItem(KEY, "declined"); } catch {}
}
